/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ChototIcons from '@assets/styles/chotot-icons.module.scss';
import TextLabel from '@app/components/AdLabel/TextLabel';
import { styled } from 'linaria/react';
import Style from './AdBody.module.scss';
// import LabelAd from '../../LabelAd';

const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1jbmbeu"
});
const AdBody = ({
  giftId,
  title,
  price,
  // priceAd,
  titleAd,
  // ribbonAd,
  commonStyle,
  locationName,
  giveaway,
  saveAdButton,
  handleImplementClickAdView,
  isEntitlement,
  isUrgentJobAd,
  companyName,
  textLabelConfig
}) => {
  // const htmlLabelTitleAd = titleAd && (
  //   <LabelAd labelInfo={titleAd} commonClass={`${commonStyle.commonStyleLabelGrid}`} />
  // );

  // const htmlLabelPriceAd = priceAd && (
  //   <LabelAd labelInfo={priceAd} commonClass={`${commonStyle.commonStyleLabelPriceGrid}`} />
  // );

  const _renderPrice = () => {
    if (giftId) {
      return <span className={commonStyle.giftCode}>
          <span className={commonStyle.giftCodeText}>{price.length > price}</span>
        </span>;
    }
    if (giveaway === true) {
      return <span className={commonStyle.giveaway}>
          <i className={`${ChototIcons.icon} ${commonStyle.giveaway_icon}`} />
          <span className={commonStyle.giveawayText}>Cho tặng</span>
        </span>;
    }
    return <div className={Style.wrapperPrice}>
        {price.length > 0 && <span className={Style.price}>
            {price.length > 20 ? `${price.substring(0, 20)}...` : price}
          </span>}
        {/* {htmlLabelPriceAd} */}
      </div>;
  };

  // const hasLabelAd = titleAd || ribbonAd || priceAd;
  const styleAdTitle = `${commonStyle.adTitleGrid} ${Style.title}`;
  const breakTitle = title.length > 50;
  if (titleAd && title.length > 35) {
    title = title.substring(0, 35).concat('...');
  } else {
    title = breakTitle ? title.substring(0, 50).concat('...') : title;
  }
  return <Wrapper>
      <div className={Style.caption} onClick={event => handleImplementClickAdView(event)}>
        {!isEntitlement && !isUrgentJobAd && <div className={styleAdTitle}>
            {/* {htmlLabelTitleAd} */}
            {title}
          </div>}
        {_renderPrice()}
        {textLabelConfig && textLabelConfig.length > 0 && !isUrgentJobAd && !isEntitlement && <TextLabel configs={textLabelConfig} customStyles={{
        marginTop: '4px',
        marginBottom: '4px'
      }} />}
      </div>

      <div className={Style.footer}>
        {companyName && (isEntitlement || isUrgentJobAd) && <span className={`${Style.adItemPostedTime} ${Style.location} ${Style.adItemCompany}`}>
            <span className={Style.text}>
              <span className={Style.companyIcon} />
              {companyName}
            </span>
          </span>}
        {locationName && <span className={`${Style.adItemPostedTime} ${Style.location}`}>
            <span className={Style.text}>
              <span className={Style.locationIcon} />
              {locationName}
            </span>
          </span>}
        {textLabelConfig && textLabelConfig.length > 0 && (isUrgentJobAd || isEntitlement) && <TextLabel configs={textLabelConfig} customStyles={{
        marginTop: '6px'
      }} />}
        {saveAdButton && saveAdButton}
      </div>
    </Wrapper>;
};
AdBody.defaultProps = {
  // ribbonAd: null,
  titleAd: null,
  // priceAd: null,
  price: '',
  locationName: '',
  giveaway: false,
  saveAdButton: null,
  isEntitlement: false,
  companyName: '',
  isUrgentJobAd: false,
  textLabelConfig: []
};
AdBody.propTypes = {
  price: PropTypes.string,
  giftId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  adTypeConfig: PropTypes.shape({
    adType: PropTypes.string
  }).isRequired,
  commonStyle: PropTypes.objectOf(PropTypes.string).isRequired,
  // ribbonAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  titleAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  // priceAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  locationName: PropTypes.string,
  giveaway: PropTypes.bool,
  saveAdButton: PropTypes.element,
  isEntitlement: PropTypes.bool,
  isUrgentJobAd: PropTypes.bool,
  companyName: PropTypes.string,
  textLabelConfig: PropTypes.arrayOf(PropTypes.shape({}))
};
export default memo(AdBody);

require("../../../../../.linaria-cache/src/components/GridAds/AdItem/AdBody/AdBody.linaria.module.css");